import * as React from 'react';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { getInitials } from '@/utils/documentUtils';
import { cn } from '@/lib/utils';

export type InitialsAvatarSize = 'sm' | 'default';

export interface InitialsAvatarProps {
  name?: string;
  fallback?: React.ReactNode;
  size?: InitialsAvatarSize;
  className?: string;
  /** Set when the name is already rendered beside it, so it is not read twice. */
  decorative?: boolean;
}

const SIZES: Record<InitialsAvatarSize, string> = {
  sm: 'size-6 text-[10px] [&_svg]:size-3.5',
  default: 'size-8 text-xs [&_svg]:size-4',
};

const InitialsAvatar = React.forwardRef<HTMLSpanElement, InitialsAvatarProps>(
  ({ name, fallback, size = 'default', className, decorative }, ref) => (
    <Avatar
      ref={ref}
      data-slot="initials-avatar"
      role={name && !decorative ? 'img' : undefined}
      aria-label={name && !decorative ? name : undefined}
      aria-hidden={decorative || undefined}
      className={cn('shrink-0 text-muted-foreground', SIZES[size], className)}
    >
      {/* Radix renders nothing at all without a Fallback child. */}
      <AvatarFallback className="revy-cjk font-medium leading-[1.5]">
        {fallback ?? getInitials(name)}
      </AvatarFallback>
    </Avatar>
  ),
);
InitialsAvatar.displayName = 'InitialsAvatar';

export { InitialsAvatar };
export default InitialsAvatar;
